<template>
  <div class="tabs">
    <div class="heading" v-if="info" style="margin-bottom: 6px;">
      <span class="title" v-text="label"></span>
      <img v-if="toolTip" :src="getImage('question-icon.svg')" alt="" @click="openPopup">
    </div>
    <div class="heading" v-else>
      <span class="title" v-text="label"></span>
    </div>

    <div class="tab-container">
      <div class="tab"
           v-for="(option, key) in options"
           v-text="option"
           :class="{active: key === value}"
           @click="change(key)"
      ></div>
    </div>
  </div>
</template>

<script>
import tooltipMixin from "@/mixins/tooltipMixin";

export default {
  name: "Tabs",

  mixins: [tooltipMixin],

  props: {
    label: {
      type: String,
      required: false,
    },
    options: {
      type: Object,
      required: true,
    },
    value: {
      type: String,
    },
    info: {
      type: Boolean,
      default: true,
    }
  },

  methods: {
    change(newValue) {
      this.$emit('change', newValue);
      this.$emit('input', newValue);
    },
    openPopup() {
      this.$store.commit('tooltips/setCurrentActive', this.toolTip);
    }
  }

}
</script>

<style scoped lang="scss">
.tabs {

  .heading {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      font-size: 14px;
      font-family: neue-haas-grotesk-display, sans-serif;
    }
  }

  .tab-container {
    border-radius: 50px;
    border: 2px solid #EBEBEB;
    display: flex;
    align-items: center;
    background-color: white;
    transition: all ease 0.3s;
    
    .tab {
      flex-grow: 1;
      text-align: center;
      border-radius: 25px;
      padding: 9px;
      max-width: 50%;
      cursor: pointer;
      display: flex;
      justify-content: center;
      font-size: 12px;
      margin: 0;
      width: 50%;
      user-select: none;
      font-family: neue-haas-grotesk-display, sans-serif;
      transition: all 0.3s ease;
      
      &.active {
        background-color: #3DB0C7;
        color: white;
      }
    }

    label {
      cursor: pointer;
      display: flex;
      justify-content: center;
      font-size: 12px;
      margin: 0;
      border-radius: 25px;
      width: 50%;
      padding: 9px;
      user-select: none;
      font-family: neue-haas-grotesk-display, sans-serif;
      transition: all 0.3s ease;
    }

    input[type="radio"] {
      display: none;
    }

    input[type="radio"]:checked + label {
      background-color: #3DB0C7;
      color: white;
    }
  }
}
</style>
